import { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface ListPageToolbarProps {
  /** Search input or wrapped search element. Rendered in the left slot. */
  search?: ReactNode;
  /** Action buttons or filter dropdowns. Rendered in the right slot. */
  actions?: ReactNode;
  /** Optional class names to append to the outer container. */
  className?: string;
  /** Optional class names to append to the actions slot wrapper (e.g. for width constraints on filter dropdowns). */
  actionsClassName?: string;
  /** Optional class names to append to the search slot wrapper (e.g. to widen it when the slot holds a filter beside the input). */
  searchClassName?: string;
}

export const ListPageToolbar = ({
  search,
  actions,
  className,
  actionsClassName,
  searchClassName,
}: ListPageToolbarProps) => {
  return (
    <div
      className={cn(
        "flex flex-col gap-4 px-4 mb-2",
        "lg:flex-row lg:items-center lg:justify-between",
        className,
      )}
    >
      {search ? (
        <div className={cn("w-full lg:max-w-md", searchClassName)}>{search}</div>
      ) : null}
      {actions ? (
        <div className={cn("flex items-center gap-2", actionsClassName)}>
          {actions}
        </div>
      ) : null}
    </div>
  );
};
